var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "order"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-tabs', [_c('b-tab', {
    staticClass: "show",
    attrs: {
      "title": _vm.$t('returnReceiptReport.returnsReceipt'),
      "active": ""
    },
    on: {
      "click": function($event) {
        _vm.loadOrderReport('Returnsreciept')
      }
    }
  }, [(_vm.orderStatus == 'Returnsreciept') ? _c('div', [_c('div', {
    staticClass: "card-headerfrmOrd"
  }, [(_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }, [(_vm.showSelectMerchant) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.merchant')) + " ")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "32px",
      "border-color": "#799497 !important"
    },
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('basic-select', {
    ref: "mrch_id",
    staticClass: "form-control",
    staticStyle: {
      "color": "rgb(20, 33, 44)",
      "padding": "8px",
      "padding-left": "13px",
      "border-radius": "0%"
    },
    attrs: {
      "id": "mrch_id",
      "options": _vm.listMerchantData1,
      "selected-option": _vm.item,
      "placeholder": _vm.$t('common.merchantPlaceholder')
    },
    on: {
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.merchant),
      callback: function($$v) {
        _vm.merchant = $$v
      },
      expression: "merchant"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.slaflag) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('sla.selectSLA')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.slastatus),
      expression: "slastatus"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "slastatus"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.slastatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('sla.selectSLA')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Within SLA",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('sla.withinsla')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Near SLA",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('sla.nearsla')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SLA Breached",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('sla.slabreached')))])])])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsType')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returnstype),
      expression: "returnstype"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "returnstype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.returnstype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsType')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rto",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.rto')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rvp",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.rvp')))])])]), _vm._v(" "), (_vm.returnstype == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.ReturnstypeErr))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsCreationFromDate')) + " ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.fromDateFlt),
      callback: function($$v) {
        _vm.fromDateFlt = $$v
      },
      expression: "fromDateFlt"
    }
  })], 1), _vm._v(" "), (_vm.OrderId == '' || _vm.fromDateFlt == '' || _vm.fromDateFlt == null) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.FromdateErr))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsCreationToDate')) + " ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "not-before": _vm.fromDateFlt,
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.toDateFlt),
      callback: function($$v) {
        _vm.toDateFlt = $$v
      },
      expression: "toDateFlt"
    }
  })], 1), _vm._v(" "), (_vm.OrderId == '' || _vm.toDateFlt == '' || _vm.toDateFlt == null) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.todateErr))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [(_vm.returnstype != 'rvp') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnStatus')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ordersubtype),
      expression: "ordersubtype"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ordersubtype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ordersubtype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnStatusPlaceHolder')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rackin",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.rackIn')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Received",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.received')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WHInscan",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.whInscan')))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.returnstype == 'rvp') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnStatus')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ordersubtype),
      expression: "ordersubtype"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ordersubtype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ordersubtype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnStatusPlaceHolder')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "created",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.created')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "qcdone",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.qcDone')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rackin",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.rackIn')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "whreceived",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.whReceived')))])])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.wmsReturnId')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "Number",
      "placeholder": _vm.$t('returnReceiptReport.wmsReturnIdPlaceholder'),
      "id": "wmsrtoid"
    },
    model: {
      value: (_vm.wmsrtoid),
      callback: function($$v) {
        _vm.wmsrtoid = $$v
      },
      expression: "wmsrtoid"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.returnstype == 'rvp') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.customerReturnId')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('returnReceiptReport.customerReturnIdPlaceHolder'),
      "id": "custreturnid"
    },
    model: {
      value: (_vm.custreturnid),
      callback: function($$v) {
        _vm.custreturnid = $$v
      },
      expression: "custreturnid"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.reverseAWB')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('returnReceiptReport.reverseAWBPlaceHolder'),
      "id": "reverseAWB"
    },
    model: {
      value: (_vm.reverseAWB),
      callback: function($$v) {
        _vm.reverseAWB = $$v
      },
      expression: "reverseAWB"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.courier')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bookmark'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CourierCompany),
      expression: "CourierCompany"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "CourierCompany"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.CourierCompany = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.transporterPlaceHolder')))]), _vm._v(" "), _vm._l((_vm.listCourierData), function(courier_obj) {
    return _c('option', {
      domProps: {
        "value": courier_obj.couriername
      }
    }, [_vm._v(_vm._s(courier_obj.couriername))])
  })], 2)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.orderID')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "OrderId",
      "placeholder": _vm.$t('common.orderIdPlaceHolder')
    },
    model: {
      value: (_vm.OrderId),
      callback: function($$v) {
        _vm.OrderId = $$v
      },
      expression: "OrderId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.clientProductId')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-product-hunt'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('clientproductid')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.selectClientProductIdPlaceHolder'),
      "id": "clientproductid"
    },
    model: {
      value: (_vm.clientproductid),
      callback: function($$v) {
        _vm.clientproductid = $$v
      },
      expression: "clientproductid"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.clientproductidErr))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.eanCode')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bookmark'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('eancode')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.eanCodePHolder'),
      "id": "eancode"
    },
    model: {
      value: (_vm.eancode),
      callback: function($$v) {
        _vm.eancode = $$v
      },
      expression: "eancode"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.clientproductidErr))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.brandName')) + " ")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "32px",
      "border-color": "#799497 !important"
    },
    attrs: {
      "left": "<i class='fa fa-product-hunt'></i>"
    }
  }, [_c('basic-select', {
    ref: "brand_id",
    staticClass: "form-control",
    staticStyle: {
      "color": "rgb(20, 33, 44)",
      "padding": "8px",
      "padding-left": "13px",
      "border-radius": "0%"
    },
    attrs: {
      "id": "brand_id",
      "options": _vm.options,
      "selected-option": _vm.branditem,
      "placeholder": _vm.$t('common.selectBrandPlaceHolder')
    },
    on: {
      "select": _vm.onSelectBrand
    },
    model: {
      value: (_vm.brand),
      callback: function($$v) {
        _vm.brand = $$v
      },
      expression: "brand"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getOrderListSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v("\n                         "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetOrderSerach
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3 col-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('returnReceiptReport.returnReceiptReport')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-8 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('common.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-4 "
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('common.table.count')) + " - " + _vm._s(this.totalRows))])]), _vm._v(" "), (_vm.download && _vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-2 col-8"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype1(1)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.downloadBtn')))])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-1 col-3"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "title": _vm.$t('common.downloadCsv'),
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getOrderListReport(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])]) : _vm._e(), _vm._v(" "), (_vm.limitExeed && _vm.show && _vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "40px"
    },
    attrs: {
      "title": _vm.$t('common.downloadXls'),
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getOrderListReportXLS(3)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  })])]) : _vm._e(), _vm._v(" "), (!_vm.limitExeed && _vm.show && _vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-1 col-3"
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "header": _vm.dataFilter2,
      "title": _vm.$t('common.downloadXls'),
      "data": _vm.listReportDataforxls,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportname
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-2 cardlistheader"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoadingforxls
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsType')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnStatus')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.wmsReturnId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.customerReturnId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.reverseAWB')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.courierCompany')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.salesChannel')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.orderID')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.clientProductId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.eanCode')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.brand')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.mrp')))])]), _vm._v(" "), (_vm.activemrpflag) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.activemrp')))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.merchantName')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.expectedQuantity')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.receivedQuantity')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.acceptedQuantity')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.rejectedQuantity')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.acceptedPutAwayQuantity')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.rejectedPutAwayQuantity')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.extraQuantity')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.excessQuantity')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.shortQuantity')))])]), _vm._v(" "), (_vm.slaflag) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('sla.sla')))])]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.listOrderReportDataArr), function(data) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.returntype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.createddatetime || data.createddate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.returnid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.clientreturnid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.awbno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.transporter))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.saleschannel))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.orderid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.clientproductid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.brand))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.mrp))]), _vm._v(" "), (_vm.activemrpflag) ? _c('td', [_vm._v(_vm._s(data.activemrp))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.merchantname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.expected_quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.recived_qty || data.received_qty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.accepted_qty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.rejected_qty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.rackin_accepted_qty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.rackin_rejected_qty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.extra_quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.excess_quantity))]), _vm._v(" "), (_vm.returntypeshow == 'rto') ? _c('td', [_vm._v(_vm._s(data.short_quantity))]) : _vm._e(), _vm._v(" "), (_vm.returntypeshow == 'rvp') ? _c('td', [_vm._v(_vm._s(data.short_qty))]) : _vm._e(), _vm._v(" "), (_vm.slaflag) ? _c('td', [_vm._v(_vm._s(data.sladatetime)), _c('br'), _vm._v(" "), (data.slastatus == 'SLA Breached') ? _c('span', {
      staticClass: "badge badge-danger",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('sla.slabreached')))]) : (data.slastatus == 'Near SLA') ? _c('span', {
      staticClass: "badge badge-warning",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_vm._v(" " + _vm._s(Math.trunc(data.breachdurationinmins / 60)) + " " + _vm._s(_vm.$t('sla.hours')) + " " + _vm._s(Math.trunc(data.breachdurationinmins % 60)) + " " + _vm._s(_vm.$t('sla.minutes')))]) : (data.slastatus == 'Within SLA') ? _c('span', {
      staticClass: "badge badge-info",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_vm._v(" " + _vm._s(Math.trunc(data.breachdurationinmins / 60)) + " " + _vm._s(_vm.$t('sla.hours')) + " " + _vm._s(Math.trunc(data.breachdurationinmins % 60)) + " " + _vm._s(_vm.$t('sla.minutes')))]) : _vm._e()]) : _vm._e()])
  }), _vm._v(" "), (_vm.totalRows == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "22",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e()], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": _vm.$t('returnReceiptReport.returnsReject')
    },
    on: {
      "click": function($event) {
        _vm.loadOrderReport('reject')
      }
    }
  }, [(_vm.orderStatus == 'reject') ? _c('div', [_c('div', {
    staticClass: "card-headerfrmOrd"
  }, [(_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }, [(_vm.showSelectMerchant) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.merchant')) + " ")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "32px",
      "border-color": "#799497 !important"
    },
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('basic-select', {
    ref: "mrch_id",
    staticClass: "form-control",
    staticStyle: {
      "color": "rgb(20, 33, 44)",
      "padding": "8px",
      "padding-left": "13px",
      "border-radius": "0%"
    },
    attrs: {
      "id": "mrch_id",
      "options": _vm.listMerchantData1,
      "selected-option": _vm.item,
      "placeholder": _vm.$t('common.merchantPlaceholder')
    },
    on: {
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.merchant),
      callback: function($$v) {
        _vm.merchant = $$v
      },
      expression: "merchant"
    }
  })], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsType')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returnstype),
      expression: "returnstype"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "returnstype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.returnstype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsType')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rto",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.rto')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rvp",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.rvp')))])])]), _vm._v(" "), (_vm.returnstype == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.ReturnstypeErr))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsCreationFromDate')) + " ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.fromDateFlt),
      callback: function($$v) {
        _vm.fromDateFlt = $$v
      },
      expression: "fromDateFlt"
    }
  })], 1), _vm._v(" "), (_vm.fromDateFlt == '' || _vm.fromDateFlt == null) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.FromdateErr))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsCreationToDate')) + " ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "not-before": _vm.fromDateFlt,
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.toDateFlt),
      callback: function($$v) {
        _vm.toDateFlt = $$v
      },
      expression: "toDateFlt"
    }
  })], 1), _vm._v(" "), (_vm.toDateFlt == '' || _vm.toDateFlt == null) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.todateErr))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [(_vm.returnstype != 'rvp') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnStatus')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ordersubtype),
      expression: "ordersubtype"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ordersubtype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ordersubtype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnStatusPlaceHolder')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rackin",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.rackIn')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Received",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.received')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WHInscan",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.whInscan')))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.returnstype == 'rvp') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnStatus')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ordersubtype),
      expression: "ordersubtype"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ordersubtype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ordersubtype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnStatusPlaceHolder')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "created",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.created')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "qcdone",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.qcDone')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rackin",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.rackIn')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WHreceived",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.whReceived')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "whclosed",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.whClosed')))])])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.reverseAWB')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('returnReceiptReport.reverseAWBPlaceHolder'),
      "id": "reverseAWB"
    },
    model: {
      value: (_vm.reverseAWB),
      callback: function($$v) {
        _vm.reverseAWB = $$v
      },
      expression: "reverseAWB"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.wmsReturnId')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "Number",
      "placeholder": _vm.$t('returnReceiptReport.wmsReturnIdPlaceholder'),
      "id": "wmsrtoid"
    },
    model: {
      value: (_vm.wmsrtoid),
      callback: function($$v) {
        _vm.wmsrtoid = $$v
      },
      expression: "wmsrtoid"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.courierCompany')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CourierCompany),
      expression: "CourierCompany"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "CourierCompany"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.CourierCompany = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.courierCompanyPlaceHolder')))]), _vm._v(" "), _vm._l((_vm.listCourierData), function(warehouse_obj) {
    return _c('option', {
      domProps: {
        "value": warehouse_obj.couriername
      }
    }, [_vm._v(_vm._s(warehouse_obj.couriername))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('CourierCompany')),
      expression: "errors.has('CourierCompany')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('CourierCompany')) + " ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.orderID')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "OrderId",
      "placeholder": _vm.$t('common.orderIdPlaceHolder')
    },
    model: {
      value: (_vm.OrderId),
      callback: function($$v) {
        _vm.OrderId = $$v
      },
      expression: "OrderId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.clientProductId')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-product-hunt'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('clientproductid')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.selectClientProductIdPlaceHolder'),
      "id": "clientproductid"
    },
    model: {
      value: (_vm.clientproductid),
      callback: function($$v) {
        _vm.clientproductid = $$v
      },
      expression: "clientproductid"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.clientproductidErr))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.brandName')) + " ")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "32px",
      "border-color": "#799497 !important"
    },
    attrs: {
      "left": "<i class='fa fa-product-hunt'></i>"
    }
  }, [_c('basic-select', {
    ref: "brand_id",
    staticClass: "form-control",
    staticStyle: {
      "color": "rgb(20, 33, 44)",
      "padding": "8px",
      "padding-left": "13px",
      "border-radius": "0%"
    },
    attrs: {
      "id": "brand_id",
      "options": _vm.options,
      "selected-option": _vm.branditem,
      "placeholder": _vm.$t('common.selectBrandPlaceHolder')
    },
    on: {
      "select": _vm.onSelectBrand
    },
    model: {
      value: (_vm.brand),
      callback: function($$v) {
        _vm.brand = $$v
      },
      expression: "brand"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getOrderRejectListSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("  " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v("\n                         "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetOrderSerach
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3 col-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsRejectReport')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4  col-8 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('common.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-4 "
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('common.table.count')) + " - " + _vm._s(this.totalRows))])]), _vm._v(" "), (_vm.download && _vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-2 col-8"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype2(1)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.downloadBtn')))])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-1 col-3"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "title": _vm.$t('common.downloadCsv'),
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getRejectListReport(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])]) : _vm._e(), _vm._v(" "), (!_vm.limitExeed && _vm.show && _vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-1 col-3 "
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "header": _vm.dataFilter2,
      "title": _vm.$t('common.downloadXls'),
      "data": _vm.listReportDataforxls,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportnamereject
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-2 cardlistheader"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoadingforxls
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsType')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnStatus')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.reverseAWB')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.courier')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.salesChannel')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.orderID')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.clientProductId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.brand')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.mrp')))])]), _vm._v(" "), (_vm.activemrpflag) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.activemrp')))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.merchantName')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.rejectedQuantity')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.rejectedReason')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.image')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.listOrderReportDataArr), function(data) {
    return (_vm.totalRows != 0) ? _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.returntype))]), _vm._v(" "), (_vm.returntypeshow == 'rto') ? _c('td', [_vm._v(_vm._s(data.returnid))]) : _vm._e(), _vm._v(" "), (_vm.returntypeshow == 'rvp') ? _c('td', [_vm._v(_vm._s(data.srid))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.createddatetime || data.createddate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.awbno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.transporter))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.saleschannel))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.orderid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.clientproductid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.brand))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.mrp))]), _vm._v(" "), (_vm.activemrpflag) ? _c('td', [_vm._v(_vm._s(data.activemrp))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.merchantname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.rejected_qty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.rejectreason))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa fa-arrow-circle-down fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "margin-right": "11px"
      },
      attrs: {
        "title": _vm.$t('returnReceiptReport.downloadZip')
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.downloadImageAsZip(data, 0)
        }
      }
    })])]) : _vm._e()
  }), _vm._v(" "), (_vm.totalRows == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "22",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e()], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPage > 1 || _vm.listOrderReportData.result.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": _vm.$t('returnReceiptReport.returnsPutaway')
    },
    on: {
      "click": function($event) {
        _vm.loadOrderReport('putaway')
      }
    }
  }, [(_vm.orderStatus == 'putaway') ? _c('div', [_c('div', {
    staticClass: "card-headerfrmOrd"
  }, [(_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }, [(_vm.showSelectMerchant) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.merchant')) + " ")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "32px",
      "border-color": "#799497 !important"
    },
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('basic-select', {
    ref: "mrch_id",
    staticClass: "form-control",
    staticStyle: {
      "color": "rgb(20, 33, 44)",
      "padding": "8px",
      "padding-left": "13px",
      "border-radius": "0%"
    },
    attrs: {
      "id": "mrch_id",
      "options": _vm.listMerchantData1,
      "selected-option": _vm.item,
      "placeholder": _vm.$t('common.merchantPlaceholder')
    },
    on: {
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.merchant),
      callback: function($$v) {
        _vm.merchant = $$v
      },
      expression: "merchant"
    }
  })], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsType')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returnstype),
      expression: "returnstype"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "returnstype"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.returnstype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.resetOffset]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsType')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rto",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.rto')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rvp",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.rvp')))])])]), _vm._v(" "), (_vm.returnstype == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.ReturnstypeErr))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsPutawayFromDate')) + " ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.fromDateFlt),
      callback: function($$v) {
        _vm.fromDateFlt = $$v
      },
      expression: "fromDateFlt"
    }
  })], 1), _vm._v(" "), (_vm.fromDateFlt == '' || _vm.fromDateFlt == null) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.FromdateErr))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsPutawayToDate')) + " ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "not-before": _vm.fromDateFlt,
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.toDateFlt),
      callback: function($$v) {
        _vm.toDateFlt = $$v
      },
      expression: "toDateFlt"
    }
  })], 1), _vm._v(" "), (_vm.toDateFlt == '' || _vm.toDateFlt == null) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.todateErr))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.wmsReturnId')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "Number",
      "placeholder": _vm.$t('returnReceiptReport.wmsReturnIdPlaceholder'),
      "id": "wmsrtoid"
    },
    model: {
      value: (_vm.wmsrtoid),
      callback: function($$v) {
        _vm.wmsrtoid = $$v
      },
      expression: "wmsrtoid"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.reverseAWB')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('returnReceiptReport.reverseAWBPlaceHolder'),
      "id": "reverseAWB"
    },
    model: {
      value: (_vm.reverseAWB),
      callback: function($$v) {
        _vm.reverseAWB = $$v
      },
      expression: "reverseAWB"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.courierCompany')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CourierCompany),
      expression: "CourierCompany"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "CourierCompany"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.CourierCompany = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.courierCompanyPlaceHolder')))]), _vm._v(" "), _vm._l((_vm.listCourierData), function(warehouse_obj) {
    return _c('option', {
      domProps: {
        "value": warehouse_obj.couriername
      }
    }, [_vm._v(_vm._s(warehouse_obj.couriername))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('CourierCompany')),
      expression: "errors.has('CourierCompany')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('CourierCompany')) + " ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.orderID')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "OrderId",
      "placeholder": _vm.$t('common.orderIdPlaceHolder')
    },
    model: {
      value: (_vm.OrderId),
      callback: function($$v) {
        _vm.OrderId = $$v
      },
      expression: "OrderId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.clientProductId')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-product-hunt'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('clientproductid')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.selectClientProductIdPlaceHolder'),
      "id": "clientproductid"
    },
    model: {
      value: (_vm.clientproductid),
      callback: function($$v) {
        _vm.clientproductid = $$v
      },
      expression: "clientproductid"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.clientproductidErr))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.brandName')) + " ")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "32px",
      "border-color": "#799497 !important"
    },
    attrs: {
      "left": "<i class='fa fa-product-hunt'></i>"
    }
  }, [_c('basic-select', {
    ref: "brand_id",
    staticClass: "form-control",
    staticStyle: {
      "color": "rgb(20, 33, 44)",
      "padding": "8px",
      "padding-left": "13px",
      "border-radius": "0%"
    },
    attrs: {
      "id": "brand_id",
      "options": _vm.options,
      "selected-option": _vm.branditem,
      "placeholder": _vm.$t('common.selectBrandPlaceHolder')
    },
    on: {
      "select": _vm.onSelectBrand
    },
    model: {
      value: (_vm.brand),
      callback: function($$v) {
        _vm.brand = $$v
      },
      expression: "brand"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getPutawayReport()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("  " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v("\n                         "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetOrderSerach
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3 col-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsPutawayReport')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4  col-8 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('common.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-4 "
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('common.table.count')) + " - " + _vm._s(this.totalRows))])]), _vm._v(" "), (_vm.download && _vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-2 col-8"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype5()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.downloadBtn')))])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-1 col-3"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "title": _vm.$t('common.downloadCsv'),
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getPutawayReport(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])]) : _vm._e(), _vm._v(" "), (!_vm.limitExeed && _vm.show && _vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-1 col-3 "
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "header": _vm.dataFilter2,
      "title": _vm.$t('common.downloadXls'),
      "data": _vm.listReportDataforxls,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportnamereject
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-2 cardlistheader"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoadingforxls
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsType')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.reverseAWB')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.courier')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.salesChannel')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.orderID')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.clientProductId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.ean')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.brand')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.mrp')))])]), _vm._v(" "), (_vm.activemrpflag) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.activemrp')))])]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.merchantName')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.putawayQuantity')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.putawayRackid')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.putawayRackType')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.putawayDateAndTime')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.putawayBy')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.listOrderReportDataArr), function(data) {
    return (_vm.totalRows != 0) ? _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.returnstype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.returnsid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.awbno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.transporter))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.saleschannel))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.orderid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.clientproductid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.brand))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.mrp))]), _vm._v(" "), (_vm.activemrpflag) ? _c('td', [_vm._v(_vm._s(data.activemrp))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.merchantname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.rackinqty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.rackid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.racktype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.rackindate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.rackinby))])]) : _vm._e()
  }), _vm._v(" "), (_vm.totalRows == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "22",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e()], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPage > 1 || _vm.listOrderReportData.result.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": _vm.$t('returnReceiptReport.outsideProduct')
    },
    on: {
      "click": function($event) {
        _vm.loadOrderReport('Outsideproduct')
      }
    }
  }, [(_vm.orderStatus == 'Outsideproduct') ? _c('div', [_c('div', {
    staticClass: "card-headerfrmOrd"
  }, [(_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsType')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returnstype),
      expression: "returnstype"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "returnstype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.returnstype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsType')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rto",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.rto')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rvp",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.rvp')))])])]), _vm._v(" "), (_vm.returnstype == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.ReturnstypeErr))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsCreationFromDate')) + " ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.fromDateFlt),
      callback: function($$v) {
        _vm.fromDateFlt = $$v
      },
      expression: "fromDateFlt"
    }
  })], 1), _vm._v(" "), (_vm.fromDateFlt == '' || _vm.fromDateFlt == null) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.FromdateErr))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsCreationToDate')) + " ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "not-before": _vm.fromDateFlt,
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.toDateFlt),
      callback: function($$v) {
        _vm.toDateFlt = $$v
      },
      expression: "toDateFlt"
    }
  })], 1), _vm._v(" "), (_vm.toDateFlt == '' || _vm.toDateFlt == null) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.todateErr))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [(_vm.returnstype != 'rvp') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnStatus')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ordersubtype),
      expression: "ordersubtype"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ordersubtype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ordersubtype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnStatusPlaceHolder')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rackin",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.rackIn')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Received",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.received')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WHInscan",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.whInscan')))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.returnstype == 'rvp') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnStatus')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ordersubtype),
      expression: "ordersubtype"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ordersubtype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ordersubtype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnStatusPlaceHolder')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "created",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.created')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "qcdone",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.qcDone')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rackin",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.rackIn')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WHreceived",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.whReceived')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "whclosed",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.whClosed')))])])])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getOustideproductSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v("\n                         "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetOrderSerach
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3 col-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('returnReceiptReport.outsideProductReport')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-8 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('common.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-4 "
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('common.table.count')) + " - " + _vm._s(this.totalRows))])]), _vm._v(" "), (_vm.download && _vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-2 col-8 "
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype3(1)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.downloadBtn')))])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-1 col-3"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "title": _vm.$t('common.downloadCsv'),
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getnotourProductList(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])]) : _vm._e(), _vm._v(" "), (!_vm.limitExeed && _vm.show && _vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-1 col-3"
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "header": _vm.dataFilter2,
      "title": _vm.$t('common.downloadXls'),
      "data": _vm.listReportDataforxls,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportnameOutside
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-2 cardlistheader"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoadingforxls
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsType')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnStatus')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.wmsReturnId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.reverseAWB')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.courierCompany')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.salesChannel')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.orderID')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.outsideProductReport')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.receivedQuantity')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.description')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.productImages')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.listOrderReportDataArr), function(data) {
    return (_vm.totalRows != 0) ? _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.returntype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.createddatetime || data.createddate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.returnstatus))]), _vm._v(" "), (_vm.returntypeshow == 'rto') ? _c('td', [_vm._v(_vm._s(data.rtoid))]) : _vm._e(), _vm._v(" "), (_vm.returntypeshow == 'rvp') ? _c('td', [_vm._v(_vm._s(data.srid))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.awbno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.couriercompany))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.saleschannel))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.orderid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.receivedqty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.description))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa fa-arrow-circle-down fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "margin-right": "11px"
      },
      attrs: {
        "title": _vm.$t('returnReceiptReport.downloadZip')
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.downloadImageAsZip(data, 1)
        }
      }
    })])]) : _vm._e()
  }), _vm._v(" "), (_vm.totalRows == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "22",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e()], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPage > 1 || _vm.listOrderReportData.result.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": _vm.$t('returnReceiptReport.refurbishedBoxchangeLog')
    },
    on: {
      "click": function($event) {
        _vm.loadOrderReport('Refurbished')
      }
    }
  }, [(_vm.orderStatus == 'Refurbished') ? _c('div', [_c('div', {
    staticClass: "card-headerfrmOrd"
  }, [(_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsType')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returnstype),
      expression: "returnstype"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "returnstype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.returnstype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsType')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rto",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.rto')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rvp",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.rvp')))])])]), _vm._v(" "), (_vm.returnstype == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.ReturnstypeErr))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsCreationFromDate')) + " ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.fromDateFlt),
      callback: function($$v) {
        _vm.fromDateFlt = $$v
      },
      expression: "fromDateFlt"
    }
  })], 1), _vm._v(" "), (_vm.fromDateFlt == '' || _vm.fromDateFlt == null) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.FromdateErr))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsCreationToDate')) + " ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "not-before": _vm.fromDateFlt,
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.toDateFlt),
      callback: function($$v) {
        _vm.toDateFlt = $$v
      },
      expression: "toDateFlt"
    }
  })], 1), _vm._v(" "), (_vm.toDateFlt == '' || _vm.toDateFlt == null) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.todateErr))]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.reverseAWB')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('returnReceiptReport.reverseAWBPlaceHolder'),
      "id": "reverseAWB"
    },
    model: {
      value: (_vm.reverseAWB),
      callback: function($$v) {
        _vm.reverseAWB = $$v
      },
      expression: "reverseAWB"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block !important",
      "margin-top": "30px",
      "width": "16px"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    staticStyle: {
      "display": "inline-block",
      "height": "16px",
      "width": "16px"
    },
    attrs: {
      "type": "checkbox",
      "id": "refurbished",
      "name": "refurbished"
    },
    on: {
      "change": function($event) {
        _vm.checkrefchange()
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "20px",
      "color": "green !important"
    }
  }, [_c('label', {
    attrs: {
      "for": "withracks1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('returnReceiptReport.refurbished')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block !important",
      "margin-top": "30px",
      "width": "16px"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    staticStyle: {
      "display": "inline-block",
      "height": "16px",
      "width": "16px"
    },
    attrs: {
      "type": "checkbox",
      "id": "boxchange",
      "name": "boxchange"
    },
    on: {
      "change": function($event) {
        _vm.checkboxchange()
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "20px",
      "color": "green !important"
    }
  }, [_c('label', {
    attrs: {
      "for": "withracks1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('returnReceiptReport.boxchange')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getRefurbishedBoxchangeSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v("\n                         "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetOrderSerach
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3 col-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('returnReceiptReport.refurbishedBoxchange')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-8 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('common.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-4 "
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('common.table.count')) + " - " + _vm._s(this.totalRows))])]), _vm._v(" "), (_vm.download && _vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-2 col-8 "
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype4(1)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.downloadBtn')))])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-1 col-3"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "title": _vm.$t('common.downloadCsv'),
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getRefurbishedBoxchangeList(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])]) : _vm._e(), _vm._v(" "), (!_vm.limitExeed && _vm.show && _vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-1 col-3"
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "header": _vm.dataFilter2,
      "title": _vm.$t('common.downloadXls'),
      "data": _vm.listReportDataforxls,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportnameRefurbishedBoxchange
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-2 cardlistheader"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoadingforxls
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsType')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnsCreatedDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.wmsReturnsId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.reverseAWB')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.orderID')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.refurbishedQuantity')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.boxChangeQuantity')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.productType')))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.listOrderReportDataArr), function(data) {
    return (_vm.totalRows != 0) ? _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.returnstype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.createddatetime))]), _vm._v(" "), (_vm.returntypeshow == 'rto') ? _c('td', [_vm._v(_vm._s(data.rtoid))]) : _vm._e(), _vm._v(" "), (_vm.returntypeshow == 'rvp') ? _c('td', [_vm._v(_vm._s(data.srid))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.awbno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.orderid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', [(data.refurbishedqty) ? _c('span', [_vm._v(_vm._s(data.refurbishedqty))]) : _c('span', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.NA')))])]), _vm._v(" "), _c('td', [(data.boxchangeqty) ? _c('span', [_vm._v(_vm._s(data.boxchangeqty))]) : _c('span', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.NA')))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.producttype))])]) : _vm._e()
  }), _vm._v(" "), (_vm.totalRows == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e()], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPage > 1 || _vm.listOrderReportData.result.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": _vm.$t('frc.frcreport')
    },
    on: {
      "click": function($event) {
        _vm.loadOrderReport('FRC')
      }
    }
  }, [(_vm.orderStatus == 'FRC') ? _c('div', [_c('div', {
    staticClass: "card-headerfrmOrd"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('frc.suborderid')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "SubOrderId",
      "placeholder": _vm.$t('frc.suborderidplaceholder')
    },
    model: {
      value: (_vm.SubOrderId),
      callback: function($$v) {
        _vm.SubOrderId = $$v
      },
      expression: "SubOrderId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("  " + _vm._s(_vm.$t('frc.awbno')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "frcawbNo",
      "placeholder": _vm.$t('frc.awbnoPlaceholder')
    },
    model: {
      value: (_vm.frcawbNo),
      callback: function($$v) {
        _vm.frcawbNo = $$v
      },
      expression: "frcawbNo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('frc.creationfromdate')) + " ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.frcfromDateFlt),
      callback: function($$v) {
        _vm.frcfromDateFlt = $$v
      },
      expression: "frcfromDateFlt"
    }
  })], 1), _vm._v(" "), (_vm.frcfromDateFlt == '' || _vm.frcfromDateFlt == null) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.frcFromdateErr))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('frc.creationtodate')) + " ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "not-before": _vm.frcfromDateFlt,
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.frctoDateFlt),
      callback: function($$v) {
        _vm.frctoDateFlt = $$v
      },
      expression: "frctoDateFlt"
    }
  })], 1), _vm._v(" "), (_vm.frctoDateFlt == '' || _vm.frctoDateFlt == null) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.frctodateErr))]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('frc.orderstatus')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.frcorderstatus),
      expression: "frcorderstatus"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "frcorderstatus"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.frcorderstatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.returnStatusPlaceHolder')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "created",
      "selected": ""
    }
  }, [_vm._v("Created")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inprocess",
      "selected": ""
    }
  }, [_vm._v("Inprocess")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rackin",
      "selected": ""
    }
  }, [_vm._v("Rackin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "closed",
      "selected": ""
    }
  }, [_vm._v("Closed")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" " + _vm._s(_vm.$t('frc.eancodeproductid')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "frceancode",
      "placeholder": "Eancode / Productid"
    },
    model: {
      value: (_vm.frceancode),
      callback: function($$v) {
        _vm.frceancode = $$v
      },
      expression: "frceancode"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getFRCListSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("  " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v("\n                                 "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetOrderSerach
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3 col-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('frc.frcreport')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4  col-8 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('common.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-4 "
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('common.table.count')) + " - " + _vm._s(this.totalRows))])]), _vm._v(" "), (_vm.download && _vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-2 col-8"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype6()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.downloadBtn')))])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-1 col-3"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "title": _vm.$t('common.downloadCsv'),
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getFRCListCSV()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])]) : _vm._e(), _vm._v(" "), (!_vm.limitExeed && _vm.show && _vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-1 col-3 "
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "header": _vm.dataFilter2,
      "title": _vm.$t('common.downloadXls'),
      "data": _vm.listReportDataforxls,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportnamefrc
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-2 cardlistheader"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoadingforxls
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('frc.returnsdate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('frc.returnstatus')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('frc.awbnum')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('frc.couriercomp')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('frc.suborderid')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('frc.clientproductid')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('frc.eanCode')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('frc.mrp')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.expectedQuantity')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('frc.receivedqty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('frc.acceptedqty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.$t('frc.rejectedqty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.shortQuantity')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.extraQuantity')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('returnReceiptReport.excessQuantity')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.$t('frc.rackinaccqty')) + " ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.$t('frc.rackinrejqty')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.listFRCReportData), function(data) {
    return (_vm.totalRows != 0) ? _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.createddatetime))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.awbno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.couriercompany))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.suborderid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.clientproductid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.mrp))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.expected_qty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.received_qty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.accepted_qty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.rejected_qty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.short_qty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.extra_qty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.excess_qty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.accepted_putaway_qty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.rejected_putaway_qty))])]) : _vm._e()
  }), _vm._v(" "), (_vm.totalRows == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "17",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e()], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPage > 1 || _vm.listFRCReportData.count > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": _vm.$t('frc.frcrejectreport')
    },
    on: {
      "click": function($event) {
        _vm.loadOrderReport('FRCReject')
      }
    }
  }, [(_vm.orderStatus == 'FRCReject') ? _c('div', [_c('div', {
    staticClass: "card-headerfrmOrd"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('frc.suborderid')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "SubOrderId",
      "placeholder": _vm.$t('frc.suborderidplaceholder')
    },
    model: {
      value: (_vm.SubOrderId),
      callback: function($$v) {
        _vm.SubOrderId = $$v
      },
      expression: "SubOrderId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("  " + _vm._s(_vm.$t('frc.awbno')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "frcawbNo",
      "placeholder": _vm.$t('frc.awbnoPlaceholder')
    },
    model: {
      value: (_vm.frcawbNo),
      callback: function($$v) {
        _vm.frcawbNo = $$v
      },
      expression: "frcawbNo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" " + _vm._s(_vm.$t('frc.eancodeproductid')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "frceancode",
      "placeholder": "Eancode / Productid"
    },
    model: {
      value: (_vm.frceancode),
      callback: function($$v) {
        _vm.frceancode = $$v
      },
      expression: "frceancode"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('frc.creationfromdate')) + " ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.frcfromDateFlt),
      callback: function($$v) {
        _vm.frcfromDateFlt = $$v
      },
      expression: "frcfromDateFlt"
    }
  })], 1), _vm._v(" "), (_vm.frcfromDateFlt == '' || _vm.frcfromDateFlt == null) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.frcFromdateErr))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('frc.creationtodate')) + " ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "not-before": _vm.frcfromDateFlt,
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.frctoDateFlt),
      callback: function($$v) {
        _vm.frctoDateFlt = $$v
      },
      expression: "frctoDateFlt"
    }
  })], 1), _vm._v(" "), (_vm.frctoDateFlt == '' || _vm.frctoDateFlt == null) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.frctodateErr))]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getFRCRejectListSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("  " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v("\n                                 "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetOrderSerach
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3 col-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('frc.frcrejectreport')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4  col-8 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('common.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-4 "
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('common.table.count')) + " - " + _vm._s(this.totalRows))])]), _vm._v(" "), (_vm.download && _vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-2 col-8"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype7()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.downloadBtn')))])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-1 col-3"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "title": _vm.$t('common.downloadCsv'),
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getFRCRejectListCSV()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])]) : _vm._e(), _vm._v(" "), (!_vm.limitExeed && _vm.show && _vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-1 col-3 "
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "header": _vm.dataFilter2,
      "title": _vm.$t('common.downloadXls'),
      "data": _vm.listReportDataforxls,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportnamefrc
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-2 cardlistheader"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoadingforxls
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('frc.awbnum')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('frc.suborderid')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('frc.clientproductid')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('frc.eanCode')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.$t('frc.rejectedqty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.$t('frc.rejectreason')) + " ")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.listFRCReportData), function(data) {
    return (_vm.totalRows != 0) ? _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.awbno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.suborderid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.clientproductid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.rejectreason))])]) : _vm._e()
  }), _vm._v(" "), (_vm.totalRows == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "14",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e()], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPage > 1 || _vm.listFRCReportData.count > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1) : _vm._e()])], 1)], 1)])])], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c847c110", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c847c110","hasScoped":true}!./src/views/components/reports/returnsreceiptreport/returnsreceiptreport.component.html
// module id = 1670
// module chunks = 0